var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.04813C16.0003 6.51922 15.5625 5.02223 14.7385 3.73441C13.9144 2.44659 12.7385 1.42189 11.3501 0.781636C9.96173 0.14138 8.41893 -0.0876158 6.90442 0.121765C5.38991 0.331145 3.96712 0.970131 2.80451 1.96306C1.6419 2.956 0.788165 4.26129 0.344396 5.72438C-0.0993733 7.18748 -0.114591 8.7471 0.300544 10.2186C0.71568 11.6901 1.54378 13.0118 2.68679 14.0272C3.82981 15.0426 5.23986 15.7092 6.75 15.9481V10.3601H4.719V8.04813H6.75V6.28513C6.70627 5.87358 6.7536 5.45745 6.88863 5.06623C7.02366 4.675 7.24309 4.31827 7.53136 4.02131C7.81964 3.72436 8.1697 3.49444 8.55674 3.34786C8.94379 3.20128 9.35833 3.14163 9.771 3.17313C10.371 3.18101 10.9696 3.23316 11.562 3.32913V5.30013H10.554C10.3823 5.27768 10.2077 5.29412 10.0432 5.34825C9.87874 5.40237 9.72853 5.49279 9.6037 5.61282C9.47887 5.73284 9.38263 5.8794 9.3221 6.04165C9.26157 6.20389 9.23829 6.37768 9.254 6.55013V8.05013H11.473L11.118 10.3621H9.25V15.9531C11.1322 15.6554 12.8464 14.6955 14.0838 13.2463C15.3213 11.7971 16.0008 9.95377 16 8.04813Z",
    fill: "#0085FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.e91f5e94913c73c0991d00f5648a6f6b.svg";
export { ForwardRef as ReactComponent };